"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.copyArray = void 0;
function copyArray(array) {
    let clonedArray = [];
    array.forEach(val => clonedArray.push(Object.assign({}, val)));
    return clonedArray;
}
exports.copyArray = copyArray;
//# sourceMappingURL=utils.js.map